import React from 'react';

import { Content } from '@motorway/motorway-storybook-cra';

import styles from './SeoPageHeader.scss';

type Props = {
  readonly content: string
}

const SeoPageHeader = ({ content } :Props) => (
  <div className={styles.component}>
    <div className={styles.topWrapper}>
      <Content wrapper={{ className: styles.contentWrapper }}>
        <div dangerouslySetInnerHTML={{ __html: content }} className={styles.container} />
      </Content>
    </div>
  </div>
);

export default SeoPageHeader;
